import actionPlans from './actionPlans'
import generalInformation from './generalInformation'
import questionControls from './questionControls'
import takeRisks from './takeRisks'

const pages = { actionPlans, generalInformation, questionControls, takeRisks }

export default pages
